import {Fragment, useEffect, useState} from 'react';
import {EditFormHeader} from './EditFormHeader';
import {Button, Grid, IconButton, Snackbar} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {WebsiteStructure} from '../../../api/models';
import {DashboardPanel} from './DashboardPanel';
import {ComponentResolver} from './ComponentResolver';
import {CompanionComponentResolver} from './CompanionComponentResolver';

interface Props {
    data: WebsiteStructure;
    refetch: VoidFunction;
}

export const EditFormLayoutBuilder = (props: Props) => {
    const [open, setOpen] = useState(false);
    const [activeSection, updateActiveSection] = useState<string | undefined>(undefined);
    const websiteId = props.data.id;

    useEffect(() => {
        if (props.data.sections.length > 0) {
            const firstSection = props.data.sections[0];
            updateActiveSection(firstSection.id);
        }
    }, [props.data]);

    const [snackBarMessage, updateSnackbarMessage] = useState<string>('');

    const throwSnackbarMessage = (message: string) => {
        updateSnackbarMessage(message);
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const action = (
        <Fragment>
            <Button size='small' onClick={handleClose}>
                Dismiss
            </Button>
            <IconButton size='small' aria-label='close' color='inherit' onClick={handleClose}>
                <CloseIcon fontSize='small' />
            </IconButton>
        </Fragment>
    );

    const section = props.data.sections.find((el) => el.id === activeSection);

    return (
        <div>
            <EditFormHeader />
            <Grid container>
                <Grid item xs={12} sm={12} md={3} xl={2} lg={3}>
                    <div
                        style={{
                            marginTop: 120,
                        }}>
                        <DashboardPanel
                            activeSection={activeSection}
                            updateActiveSection={(newSectionType: string) => {
                                updateActiveSection(newSectionType);
                            }}
                            throwSnackbarMessage={throwSnackbarMessage}
                            websiteStructure={props.data}
                            refetch={props.refetch}
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={12} md={9} xl={10} lg={9}>
                    {section ? (
                        <ComponentResolver
                            websiteId={websiteId}
                            section={section}
                            throwSnackbarMessage={throwSnackbarMessage}
                            refetch={props.refetch}
                        />
                    ) : (
                        <></>
                    )}
                    {section ? (
                        <CompanionComponentResolver
                            websiteId={websiteId}
                            section={section}
                            throwSnackbarMessage={throwSnackbarMessage}
                            refetch={props.refetch}
                        />
                    ) : (
                        <></>
                    )}
                </Grid>
            </Grid>
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                open={open}
                action={action}
                autoHideDuration={2500}
                message={snackBarMessage}
            />
        </div>
    );
};
